import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import ConfirmModal from './ConfirmModal';
import NoticeModal from './NoticeModal';

const WithdrawalRequestPage = ({ panelId }) => {
    const [requests, setRequests] = useState([]);
    const isManagement = window.location.hostname.startsWith('yonetim');
    const _cu = JSON.parse(localStorage.getItem('user') || '{}');
    const _role = _cu.role;
    const canDoWithdraw = _role === 'izleyici' ? false : (_role === 'yardimci' ? !!_cu.canWithdraw : true);
    const isYonetimRole = _role === 'yonetim' || _role === 'master_admin';
    const [confirmState, setConfirmState] = useState({ open: false, message: '', onConfirm: null, danger: false });
    const askConfirm = (message, onConfirm, danger = false) => setConfirmState({ open: true, message, onConfirm, danger });
    const closeConfirm = () => setConfirmState({ open: false, message: '', onConfirm: null, danger: false });
    const [notice, setNotice] = useState({ open: false, message: '', danger: false });
    const showNotice = (message, danger = false) => setNotice({ open: true, message, danger });

    const fetchRequests = useCallback(async () => {
        try {
            const currentUser = JSON.parse(localStorage.getItem('user'));
            const activePanelId = panelId || currentUser?.panelId;
            // Sadece 'new' statüsündeki istekleri getir
            const res = await api.getWithdrawals({ status: 'new', panelId: activePanelId || '' });
            setRequests(res.data);
        } catch (error) {
            console.error('Veri çekme hatası', error);
        }
    }, [panelId]);

    useEffect(() => {
        document.title = 'PayzoPay - Çekim Talebi Al';
        fetchRequests();
        const interval = setInterval(fetchRequests, 5000);
        return () => clearInterval(interval);
    }, [fetchRequests]);

    const logAction = async (action, details) => {
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            const activePanelId = panelId || user?.panelId;
            const username = user ? user.username : 'Bilinmiyor';
            await api.createLog({ username, action, details, panelId: activePanelId });
        } catch (error) {
            console.error('Loglama hatası:', error);
        }
    };

    const handleProcess = async (id) => {
        try {
            // Durumu 'processing' yap, böylece bu sayfadan çıkıp Havuz sayfasına düşecek
            await api.updateWithdrawalStatus(id, 'processing');
            fetchRequests(); // Listeyi yenile
            logAction('Çekim İşleme Alma', `Talep ID: ${id} işleme alındı.`);
        } catch (error) {
            showNotice('İşlem başarısız.', true);
        }
    };

    const handleDelete = async (id) => {
        try {
            await api.deleteWithdrawal(id);
            fetchRequests();
            logAction('Çekim Silme', `Talep ID: ${id} silindi.`);
        } catch (error) {
            showNotice('Silme başarısız.', true);
        }
    };

    const getStatusRowBackground = (status) => {
        // Genelde 'new' gelecek ama yapı hazır olsun
        switch (status) {
            case 'new': return 'rgba(255, 206, 84, 0.5)';
            default: return 'var(--table-row-even)';
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <h2 style={{ color: '#fff', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ background: '#dc3545', color: '#fff', padding: '4px 14px', borderRadius: '6px', fontSize: '0.6em', fontWeight: 'bold', letterSpacing: '1px' }}>ÇEKİM</span>
                Gelen Çekim Talepleri
            </h2>

            <div style={{ backgroundColor: 'var(--card-bg)', borderRadius: '15px', boxShadow: 'var(--shadow)', overflow: 'hidden', padding: '20px' }}>
                <table cellPadding="15" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 10px', color: 'var(--text-color)' }}>
                    <thead>
                        <tr style={{ backgroundColor: 'var(--table-header-bg)', borderBottom: '2px solid var(--border-color)', textAlign: 'left' }}>
                            <th>ID</th>
                            <th>İsim Soyisim</th>
                            <th>Kullanıcı Adı</th>
                            <th>Banka Adı</th>
                            <th>Miktar</th>
                            <th>Tarih</th>
                            <th>İşlem</th>
                        </tr>
                    </thead>
                    <tbody>
                        {requests.length === 0 ? (
                            <tr><td colSpan="7" style={{ textAlign: 'center' }}>Yeni talep bulunmuyor.</td></tr>
                        ) : (
                            requests.map(req => {
                                const rowBg = getStatusRowBackground(req.status);
                                const radius = '15px';
                                return (
                                    <tr key={req._id}>
                                        <td style={{ backgroundColor: rowBg, borderTopLeftRadius: radius, borderBottomLeftRadius: radius }}>{req.siteTransactionNo || ('#' + String(req._id).slice(-6))}</td>
                                        <td style={{ backgroundColor: rowBg }}>{req.name}</td>
                                        <td style={{ backgroundColor: rowBg }}>{req.username}</td>
                                        <td style={{ backgroundColor: rowBg }}>{req.bank}</td>
                                        <td style={{ backgroundColor: rowBg }}>{Number(req.amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                        <td style={{ backgroundColor: rowBg }}>{new Date(req.createdAt).toLocaleString()}</td>
                                        <td style={{ backgroundColor: rowBg, borderTopRightRadius: radius, borderBottomRightRadius: radius }}>
                                            <div style={{ display: 'flex', gap: '6px' }}>
                                                {canDoWithdraw && (
                                                <button
                                                    onClick={() => askConfirm('Bu çekim talebini işleme almak istediğinize emin misiniz?', () => handleProcess(req._id))}
                                                    style={{ padding: '5px 10px', backgroundColor: '#17a2b8', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                                                >
                                                    İşleme Al
                                                </button>
                                                )}
                                                {isManagement && isYonetimRole && (
                                                    <button
                                                        onClick={() => askConfirm('Bu çekim talebini SİLMEK istediğinize emin misiniz? Bu işlem geri alınamaz.', () => handleDelete(req._id), true)}
                                                        style={{ padding: '5px 10px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                                                    >
                                                        Sil
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>

            <ConfirmModal
                open={confirmState.open}
                message={confirmState.message}
                danger={confirmState.danger}
                onConfirm={() => { if (confirmState.onConfirm) confirmState.onConfirm(); closeConfirm(); }}
                onCancel={closeConfirm}
            />

            <NoticeModal
                open={notice.open}
                message={notice.message}
                danger={notice.danger}
                onClose={() => setNotice({ open: false, message: '', danger: false })}
            />
        </div>
    );
};

export default WithdrawalRequestPage;